/* eslint-disable react-hooks/exhaustive-deps */
import * as app from "../../services/AppService"
import * as http from "../../services/http"
import { Select, Input, DatePicker, Textarea } from "../../components";
import React, { useState, useEffect } from "react" 
import Dialog from "./Dialog";
import { ResultVM } from "../../models/Core/result-vm";
import { ArchiveModel } from "../../models/archive-model";


export interface ArchiveDialogProps {
    model: ArchiveModel
    show: boolean
    onOk?:()=>void
}

 function ArchiveDialog(props: ArchiveDialogProps) {

    const initModel = {
        ID: "0",
        Reason_Kind: "",
        Parent_ID: "",
        Date: app.today(),
        Reason: "",
        Note: "",
    };

    const [model, setModel] = useState<ArchiveModel>(initModel);
     
    function save() {
        http.post("/ClientsManagement/SaveArchive", model, (res: ResultVM) => {
            app.showRespMsg(res, () => {
                props.onOk?.();
                app.hideArchive()
            })
        });
    }

    useEffect(() => {
        if (props.show)
            setModel(old => ({ ...old, ...props.model }));
        else
            setModel(initModel)
    }, [props.show])

     return (
         <Dialog {...props} show={props.show} title="Archiving" size="md" okLabel="Save" ok={save} onClose={app.hideArchive}>
            <DatePicker model={model.Date}
                onChange={Date => setModel(old => ({ ...old, Date }))} />

            <Input model={model.Reason} label="Notes"
                onChange={Reason => setModel(old => ({ ...old, Reason }))} />

            <Select model={model.Reason_Kind} label="Reason"
                options={app.GetKeyValueArr(["CreateData", "EditData", "PrintForm", "FrmRemittDoc", "CardPrintKYC",])}
                onChange={Reason_Kind => setModel(old => ({ ...old, Reason_Kind }))} />

             <Textarea rows={3} model={model.Note} label="Notice"
                onChange={Note => setModel(old => ({ ...old, Note }))} />

        </Dialog>
    );
}
ArchiveDialog.defaultProps = {
    show:false
}
export default ArchiveDialog